/* eslint-disable @typescript-eslint/no-explicit-any */
import { SignalRCore } from "./signalR/core";
import { hubs } from "./signalR/config";

export interface IApiClient {
  me_GetProfile: () => Promise<any>;
  me_UpdateProfile: (data: any) => Promise<any>;

  request: (input: RequestInfo, init?: RequestInit) => Promise<Response>;
  get: (url: string, queryParams: any) => Promise<Response>;
  post: (url: string, data: any, queryParams: any) => Promise<Response>;
  put: (url: string, data: any, queryParams: any) => Promise<Response>;
  delete: (url: string, queryParams: any) => Promise<Response>;

  getAccessToken: () => Promise<string>;

  setTokenGetter: (getter: () => Promise<string>) => void;
}

/**
 * API client
 */
export class ApiClient implements IApiClient {
  public async me_GetProfile() {
    return {};
  }
  public async me_UpdateProfile() {
    return {};
  }

  //url, method, data, signal, token
  public async request(resource: string, options?: RequestInit) {
    const token = await this.getAccessToken();
    const headers = {
      Authorization: `Bearer ${token}`,
      "Content-Type": "application/json; charset=utf-8",
      Accept: "application/json",
      ProjectAssistantHub: SignalRCore.connectionId(hubs.projectAssistant) || undefined,
    };

    return fetch(resource, {
      ...options,
      headers: {
        ...options?.headers,
        ...headers,
      },
    });
  }

  public async get(url: string, queryParams: any) {
    return this.request(url + this.parseParams(queryParams), {});
  }

  public async post(url: string, data: any, queryParams: any) {
    const options = {
      method: "POST",
      body: JSON.stringify(data),
    };
    return this.request(url + this.parseParams(queryParams), options);
  }

  public async put(url: string, data: any, queryParams: any) {
    const options = {
      method: "PUT",
      body: JSON.stringify(data),
    };
    return this.request(url + this.parseParams(queryParams), options);
  }

  public async delete(url, queryParams) {
    const options = {
      method: "DELETE",
    };
    return this.request(url + this.parseParams(queryParams), options);
  }

  public async getWithAbort(url, queryParams) {
    const controller = new AbortController();
    const options = {
      method: "GET",
      signal: controller.signal,
    };
    return {
      abort: () => controller.abort(),
      request: this.request(url + this.parseParams(queryParams), options),
    };
  }

  parseParams(queryParams) {
    if (!queryParams) return "";
    const params = Object.keys(queryParams)
      .map((key) => {
        if (queryParams[key] === undefined) {
          return false;
        }
        const value = encodeURIComponent(queryParams[key]);
        if (value === "") {
          return false;
        }
        return `${key}=${value}`;
      })
      .filter((i) => i !== false);
    return params.length ? "?" + params.join("&") : "";
  }

  // Token getter method
  public async getAccessToken() {
    return "";
  }

  // Token setter method
  public setTokenGetter(getter: () => Promise<string>) {
    this.getAccessToken = getter;
  }
}
